module.exports = __webpack_public_path__ + "img/fraud-alert-icon.07fe6e02.png";